<script>
    import { layoutOption, newOrderId, apiConfig, mode, memberInfo, queryStr, token, resolveIcpPayType, cipherText, appVer } from '../store/inapp-store'
    import { inappFetch } from '../store/inapp-auth'
    import { Modal, Loader } from '../components';
    import { onMount, onDestroy } from 'svelte';
    import { onlinePaymentIcp } from '../store/openpoint'

    $layoutOption.showBanner = false
    $layoutOption.showCarousel = false

    $: isIcpA2A = resolveIcpPayType($appVer) === 'icpo_a2a'

    let payResult = {
        status: '',
        data: ''
    }

    let modal = {
        title : '登記借杯',
        message : '交易取消',
        type: 'alert'
    }

    let warningModal = {
        title: '登記借杯',
        message: '即將前往 icashpay App 進行付款。若在 icashpay 中取消交易或不小心關閉 App，請手動切回 OPENPOINT App，系統將自動確認結果。',
        type: 'alert'
    }

    let isOpen = false
    let isWarning = false
    let isA2AWaiting = false
    let loader = { content : '線上支付準備中...' }
    let isBlock = true
    let timeoutTimer = null
    let countdownInterval = null
    let countdown = 360
    let showCountdown = true

    function formatCountdown(sec) {
        const m = Math.floor(sec / 60)
        const s = sec % 60
        return `${m}:${s.toString().padStart(2, '0')}`
    }

    onDestroy(() => {
        if (timeoutTimer) clearTimeout(timeoutTimer)
        if (countdownInterval) clearInterval(countdownInterval)
    })

    onMount(() =>{
        if($mode === 'app') {
            try {
                if (isIcpA2A) {
                    isBlock = false
                    isWarning = true
                } else {
                    startOnlinePayment()
                    startIcpPolling()
                }
            } catch(e) {
                modal.message  = e.msg
                isBlock = false
                isOpen = true
            }
        } else {
            loader.content = '模擬icashpay交易成功情境...'
            isBlock = true
            setTimeout(doMockOnlinePayment, 1000)
        }
    })

    function onConfirmPayment() {
        isWarning = false
        isBlock = false
        isA2AWaiting = true
        $layoutOption.navBackUrl = `/register${$queryStr}`
        countdownInterval = setInterval(() => {
            if (countdown > 0) countdown--
            showCountdown = !showCountdown
        }, 1000)
        startIcpA2APayment()
    }

    function goBackToRegister() {
        window.location.replace(`/register${$queryStr}`)
    }

    function startIcpA2APayment() {
        // 儲存待確認訂單；OPAPP 返回首頁後由 Home.svelte 導向 /op-icp-check 查詢結果
        localStorage.setItem('icp_a2a_pending', JSON.stringify({ orderId: $newOrderId, gid: $memberInfo.gid, timestamp: Date.now() }))
        startOnlinePayment()

        // 若 6 分鐘內未返回則視為逾時
        timeoutTimer = setTimeout(() => {
            localStorage.removeItem('icp_a2a_pending')
            isBlock = false
            isA2AWaiting = false
            modal.message = '交易授權逾時，請先查詢紀錄查詢，以確認是否訂單成立，或是稍後進行重試'
            isOpen = true
        }, 6 * 60 * 1000)
    }

    function startIcpPolling() {
        let timer

        if(document.getElementById('payStatus') !== null) {
            timer = setInterval(function(){
                var payStatus = document.getElementById('payStatus').value;
                console.log('payStatus', payStatus)
                if(payStatus !== '') {
                    payResult.status = payStatus
                    clearInterval(timer)

                    // ICP 線上支付回傳交易結果
                    // 0:未定義
                    // 1:執行成功
                    // 2:取消
                    if(payResult.status === '1') {
                        nextStep()
                        return false
                    } else {
                        if(payResult.status === '2')  {
                            modal.message  = '交易取消'
                        } else {
                                modal.message  = '發生錯誤，請先查詢紀錄查詢，以確認是否訂單成立，或是稍後進行重試'
                        }
                        isBlock = false
                        isOpen = true
                    }
                }
            },1000)
        }
    }

    /**
     * 開啟線上支付流程
     */
    function startOnlinePayment() {

        // 取得線上支付所需參數
        inappFetch(`${$apiConfig.apiUrl}/payment/data?code=${$apiConfig.apiKey}&id=${$newOrderId}&gid=${$memberInfo.gid}&payType=icpo&token=${$token}&ct=${encodeURIComponent($cipherText)}`, {
            method: 'GET'
        })
        .then(response => response.json())
        .then(d => {
                console.log(d)
                if(d.returnCode === '0000') {
                    // 呼叫JS線上支付介面
                    onlinePaymentIcp(d.info.source, d.info.data)
                } else {
                    isBlock = false
                    isOpen = true
                }
            })
    }

    /**
     * 模擬線上支付交易成功
     */
    function doMockOnlinePayment() {
        fetch(`${$apiConfig.apiUrl}/mock/payment?code=${$apiConfig.apiKey}`, {
            method: 'POST',
            body:JSON.stringify({id : $newOrderId })
        })
        .then(response => response.json())
        .then(d => {
            console.log(d)
            nextStep()
        });
    }

    function handleModalClose() {
        window.location.replace(`/home${$queryStr}`)
    }

    /**
     * 前往交易完成頁
     */
    function nextStep() {
        location.href = 'register-result'
    }

</script>

{#if !isIcpA2A}
<input type="hidden" id="payStatus" >
<input type="hidden" id="payErrorCode" >
<input type="hidden" id="payResultMsg" >
{/if}

<Modal modal={warningModal} isOpen={isWarning} on:closeModal={onConfirmPayment}></Modal>
<Modal {modal} {isOpen} on:closeModal={handleModalClose}></Modal>
<Loader {loader} {isBlock}></Loader>

{#if isA2AWaiting}
<div class="icp-waiting">
    <img src="/img/2023_open_loading.gif" alt="" width="140">
    <p class="icp-waiting-text">請在6分鐘內付款<br>如取消付款，請切回 OPENPOINT App</p>
</div>
<div class="pay-d-fx-btm">
    <button class="pay-d-send submit-a w-100" on:click={goBackToRegister}>
        {showCountdown ? formatCountdown(countdown) : '返回上頁'}
    </button>
</div>
{/if}

<style>
    .icp-waiting {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: calc(100vh - 3.125rem);
        padding: 0 1rem;
    }
    .icp-waiting-text {
        margin-top: 1rem;
        font-size: 1rem;
        text-align: center;
        color: #555;
        padding: 0 1.5rem;
        line-height: 1.6;
    }
</style>
